/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

import { Asset, AssetUtils, Channel, Ducks, EntryPoint, EventTrigger, XError } from '@wit/vtv-x-foundation-lib';

// PUBLIC
export function addInitializationErrorEvent(error: XError): void {
  Ducks.SystemEvents.sendErrorCodesEvent(error, EventTrigger.INITIALIZATION);
}

export function addSettingsErrorEvent(error: XError): void {
  Ducks.SystemEvents.sendErrorCodesEvent(error, EventTrigger.SETTINGS);
}

export function addErrorEventByEntryPoint(error: XError, entryPoint?: EntryPoint): void {
  let trigger: EventTrigger;
  switch (entryPoint) {
    case EntryPoint.RECORDINGS:
    case EntryPoint.SCHEDULED_RECORDINGS:
    case EntryPoint.PURCHASES:
    case EntryPoint.WATCH_NEXT:
      trigger = EventTrigger.MY_TV;
      break;
    case EntryPoint.CLU:
    case EntryPoint.TV_GUIDE:
      trigger = EventTrigger.EPG_TV_GUIDE;
      break;
    case EntryPoint.ONDEMAND:
      trigger = EventTrigger.ON_DEMAND;
      break;
    default:
      trigger = EventTrigger.GENERIC;
  }
  Ducks.SystemEvents.sendErrorCodesEvent(error, trigger);
}

export function addPlayerErrorEvent(error: XError, asset?: Asset, channel?: Channel, isLive?: boolean): void {
  const playerError = XError.fromAssetError(error, isLive, asset, channel);
  Ducks.SystemEvents.sendErrorCodesEvent(
    playerError,
    asset && AssetUtils.isRecording(asset) ? EventTrigger.RECORDINGS : EventTrigger.PLAYOUT
  );
}
